import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54c9fa36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FTLOrderSenderAndStops" }
const _hoisted_2 = { class: "FTLOrderSenderAndStops__container" }
const _hoisted_3 = { class: "container__block" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block__title" }, "Отправитель", -1))
const _hoisted_5 = { class: "block__content" }
const _hoisted_6 = { class: "block__field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Название", -1))
const _hoisted_8 = { class: "field__value" }
const _hoisted_9 = { class: "block__field" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Адрес", -1))
const _hoisted_11 = { class: "field__value" }
const _hoisted_12 = { class: "block__field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Телефон", -1))
const _hoisted_14 = { class: "field__value" }
const _hoisted_15 = { class: "block__field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Город", -1))
const _hoisted_17 = { class: "field__value" }
const _hoisted_18 = { class: "block__field" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Имя", -1))
const _hoisted_20 = { class: "field__value" }
const _hoisted_21 = { class: "container__block" }
const _hoisted_22 = {
  class: "block__title",
  style: {"margin-bottom":"0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ftl_additional_service = _resolveComponent("ftl-additional-service")!
  const _component_ftl_order_stock_delivery_note = _resolveComponent("ftl-order-stock-delivery-note")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              (_ctx.sender)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.sender.title || '-'), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" - ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              (_ctx.sender)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.sender.full_address || '-'), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" - ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              (_ctx.sender)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.sender.additional_phone)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.sender.phone) + ", " + _toDisplayString(_ctx.sender.additional_phone), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.sender.phone), 1)
                        ], 64))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" - ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              (_ctx.sender)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.sender.city || '-'), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" - ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              (_ctx.sender)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.sender.full_name || '-'), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" - ")
                  ], 64))
            ])
          ])
        ]),
        (_ctx.additionalService && _ctx.additionalService.length)
          ? (_openBlock(), _createBlock(_component_ftl_additional_service, {
              key: 0,
              class: "mt-3",
              short: "",
              "additional-service": _ctx.additionalService
            }, null, 8, ["additional-service"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, " Остановки (" + _toDisplayString(_ctx.stockDeliveryNotes.length) + ") ", 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockDeliveryNotes, (stock_delivery_note, index) => {
        return (_openBlock(), _createBlock(_component_ftl_order_stock_delivery_note, {
          key: `stock-delivery-note-${index}`,
          "stock-delivery-note": stock_delivery_note,
          "is-uploading-scan": _ctx.isUploadingScan,
          "is-printing-invoice": _ctx.isPrintingInvoice,
          onUploadScan: _ctx.onUploadScan,
          onPrintInvoice: ($event: any) => (_ctx.onPrintInvoice(index))
        }, null, 8, ["stock-delivery-note", "is-uploading-scan", "is-printing-invoice", "onUploadScan", "onPrintInvoice"]))
      }), 128))
    ])
  ]))
}